import React from "react";
import "../App.css";

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 RiderSync</p>
    </footer>
  );
}

export default Footer;
